


























import { computed, defineComponent } from "@vue/composition-api";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseInputFile from "@/components/BaseInputFile";
import LoadingThumbnail from "@/components/ContentLoadingPlaceholders/components/LoadingThumbnail.vue";
import { FormFileData } from "@/views/PageBecomeCreator/types";
import PayeeInfoPreview from "./PayeeInfoPreview.vue";

export default defineComponent({
  name: "PayeeInfoInputFile",
  components: { LoadingThumbnail, BaseInputFile, PayeeInfoPreview, BaseButton, BaseIcon },
  props: {
    value: { type: Object as () => FormFileData, readonly: true },
    uploadingProgress: { type: Number, readonly: true },
    loading: { type: Boolean, readonly: true, default: false },
    accept: { type: Array as () => string[], default: () => ["image"] },
  },
  setup(props) {
    const inputSrc = computed(() => {
      if (!props.value || !props.value.data) return "";
      return props.value.data instanceof FileList
        ? URL.createObjectURL(props.value.data[0])
        : MediaFilesController.getImageThumbnail(props.value.data.urlPart, "480p");
    });

    return { inputSrc };
  },
});
